module.exports = __webpack_public_path__ + "static/img/1.a9e40eb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/3/zh/1.png
// module id = kxcU
// module chunks = 0